import { StoryblokArticleOverviewPage } from './StoryblokArticleOverviewPage'

export default StoryblokArticleOverviewPage
